import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Catcher } from '../';
import { IGetApiType } from '../../REST';
import { IShowFormComponent, IZoneInfo } from '../../interfaces';
import { useRouterStore } from '../../hooks';
import { abortSelectedFetch, cleanApiMessages, getZoneById } from '../../middleware';
import { EditZoneForm } from './Components';

const emptyZone: IZoneInfo = { id: '' };

export const Zone: React.FC<IShowFormComponent> = observer(({ isEdit }: IShowFormComponent) => {
    const routerStore = useRouterStore();
    const [id, setId] = useState('');
    const [zone, setZone] = useState<IZoneInfo>(emptyZone);
    const usedApiTypes: IGetApiType[] = ['GET_ZONE'];

    const goOut = (): void => {
        abortSelectedFetch(usedApiTypes);
        cleanApiMessages();
    };

    const goToList = (): void => {
        routerStore.goTo('ZonesList');
        goOut();
    };

    const _getZone = async (zoneId: string): Promise<void> => {
        const info = await getZoneById(zoneId);
        if (!info) {
            goToList();
            return;
        }
        setZone(info);
    };

    useEffect(() => {
        return (): void => {
            goOut();
        };
    }, []);

    useEffect(() => {
        if (id && isEdit) {
            _getZone(id);
        }
    }, [id]);

    useEffect(() => {
        if (routerStore.routerState.params.id) {
            setId(routerStore.routerState.params.id);
        }
    }, [routerStore.routerState.params.id]);

    const setEdit = (nextEdit?: boolean): void => {
        if (nextEdit && id) {
            abortSelectedFetch(usedApiTypes);
            _getZone(id);
            routerStore.goTo('ZoneEdit', { params: { id } });
            return;
        }
        goToList();
    };

    return (
        <Catcher>
            <EditZoneForm initialValues={zone} setEditMode={setEdit} />
        </Catcher>
    );
});
